import React, { Component } from "react";
import { BrowserRouter, Link, Redirect, Route, Switch } from "react-router-dom";

import Logo from "./images/logo.png";
import { Home } from "./views/Home";
import { Profile } from "./views/Profile";
import { AddLift } from "./views/AddLift";
import { About } from "./views/About";

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="flex flex-col-reverse md:flex-col h-screen">
          {/* Desktop- Logo */}
          <div className="invisible md:visible h-0 md:h-20 xs:overflow-auto md:overflow-visible bg-black text-white flex items-center xs:mb-12 mb">
            <div className="w-full md:w-5/6 order-2 md:order-1 text-center md:text-left p-4">
              <Link to="/">
                <img
                  alt="Strongman Lifts"
                  src={Logo}
                  className="ml-8 mr-auto md:ml-0"
                  style={{ height: "30px" }}
                />
              </Link>
            </div>

            {/* Spacer */}
            <div className="w-18 w-12 order-1 md:order-2 md:ml-auto" />

            {/* Desktop - About link */}
            <div className="flex order-3 items-center text-center">
              <Link
                to="/about"
                className="mx-4 text-sm font-bold tracking-[0.16em] uppercase text-white transition-colors hover:text-red-500"
              >
                About
              </Link>
            </div>

            {/* Desktop - Add Lift button */}
            <div className="flex order-3 text-center">
              <div className="m-1 md:mx-4">
                <Link
                  to="/add-lift"
                  className="h-12 bg-red-500 px-5 text-sm font-bold tracking-[0.16em] uppercase text-white transition-colors hover:bg-red-100 flex items-center"
                >
                  Add Lift
                </Link>
              </div>
            </div>
          </div>

          {/* Mobile - Logo */}
          <div className="visible md:invisible sm:h-0 bg-black order-4 w-full py-2 relative flex items-center justify-center">
            <Link to="/">
              <img
                alt="Strongman Lifts"
                src={Logo}
                className="mx-auto"
                style={{ height: "30px" }}
              />
            </Link>
            <Link
              to="/about"
              className="absolute right-4 text-xs font-bold tracking-[0.16em] uppercase text-white"
            >
              About
            </Link>
          </div>

          {/* Mobile - Add Lift button */}
          <Link
            to="/add-lift"
            className="fixed w-full h-12 bottom-0 z-50 bg-red-500 text-center md:invisible md:mx-4 text-white p-2 flex items-center justify-center"
          >
            Add Lift
          </Link>

          <div className="flex-1 min-h-0 overflow-y-auto pb-16 md:pb-0">
            <Switch>
              <Route path="/add-lift" component={AddLift} />
              <Route path="/athlete/:uid" component={Profile} />
              <Route path="/about" component={About} />
              <Route path="/" component={Home} />
              <Route path="**">
                <Redirect to="/" />
              </Route>
            </Switch>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
